// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"680e7b5e","563":"c131f327","740":"ba9c32d5"}[chunkId] + ".chunk.css";
};